<ion-header>
  <ion-toolbar color="primary">
    <ion-title slot="start">{{ title }}</ion-title>
    <ion-button slot="end" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <mat-calendar
    class="calendrier"
    (selectedChange)="selectedChanged($event)"
    [(selected)]="selectedDate"
    [startAt]="selectedDate"
    [dateClass]="dateClass"
    [minDate]="minDate"
    [maxDate]="maxDate"
  ></mat-calendar>
</ion-content>
